import { ActionsUnion, createAction } from "../definitions";
import { FeedVersionActionTypes } from "./types";

export interface IFeedVersionPayload {
    userId: string;
    feedVersions: IIdDictionary<string | IIdDictionary<string>>;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FeedVersionActions = {
    setFeedVersions: (payload: IFeedVersionPayload) => createAction(FeedVersionActionTypes.SET_FEEDVERSIONS, payload),
    /**
     * Used to clear Feed Versions from storage
     * @param keepUsers Optional array of {@link IUser}s for which Feed Versions should be kept.
     */
     clearFeedVersions: (keepUsers?: IUser[]) => createAction(FeedVersionActionTypes.CLEAR_FEEDVERSIONS, keepUsers)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FeedVersionActions = ActionsUnion<typeof FeedVersionActions>;